module.exports = __webpack_public_path__ + "img/418.cc9ebf4f.jpg";